export default "__VITE_ASSET__ChfhCtpV__"